import { getAll, put } from 'redux/api/KpiVariableOptions'

import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

export function tryGetAllKpiVariableOptions() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryPutKpiVariableOptions(
  economySetId: string,
  kpiVariableId: string,
  accounts: string[],
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    put(kpiVariableId, {
      data: { accounts, economy_set_id: economySetId }
    })
      .then((response) => {
        dispatch(actions.updateSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.AccountLevelUpdated))

        callback?.()
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.AccountLevelUpdatedFailed))

        callback?.(true)
      })
  }
}

export const useKpiVariableOptionActions = () => {
  return {
    tryGetAllKpiVariableOptions: useThunkActions(tryGetAllKpiVariableOptions),
    tryPutKpiVariableOptions: useThunkActions(tryPutKpiVariableOptions)
  }
}
